<template>
	<div id="app-mfmm">
		<hero-section/>
		<prize-section @showLightbox="showLightbox = true" />
		<moments-section ref="moments" @showLightbox="showLightbox = true"/>
		<the-lightbox v-if="showLightbox" @reopen="reopen" @hideLightbox="hideLightbox();"/>
	</div>
</template>

<script>
import HeroSection from './components/HeroSection';
import PrizeSection from './components/PrizeSection';
import MomentsSection from './components/MomentsSection';
import TheLightbox from './components/TheLightbox';

export default {
	name: 'app',
	components: { HeroSection, PrizeSection, MomentsSection, TheLightbox },
	data () {
		return {
			showLightbox: false,
		};
	},
	created () {
		document.documentElement.style.WebkitOverflowScrolling = 'touch';
		document.body.style.WebkitOverflowScrolling = 'touch';
	},
	watch: {
		showLightbox: function (newVal, oldVal) {
			if (newVal) {
				document.documentElement.style.overflow = 'hidden';
				document.body.style.overflow = 'hidden';
			} else {
				document.documentElement.style.overflow = 'auto';
				document.body.style.overflow = 'auto';
			}
		},
	},
	methods: {
		reopen () {
			this.$refs.moments.reopen(this.$root.activeMoment === 'ocean' ? 'forest' : 'ocean');
		},
		hideLightbox () {
			this.showLightbox = false;
			this.$store.commit('lightboxImage', '');
		},
	},
};
</script>

<style lang=less>
	@import (reference) './assets/_mixins.less';
	@import (reference) './assets/_breakpoints.less';

	#app-mfmm { margin-top: -183px; }

	@media @mobile {
		html, body { position: relative; width: 100%; height: 100%; overflow: auto; }
	}
</style>



// WEBPACK FOOTER //
// src/App.vue